class ProductContent extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const contentHeight = this.els.content?.element.offsetHeight || 0
    const styleHeight = this.els.style?.element.offsetHeight || 0
    const tabsHeight = this.els.tabs?.element.offsetHeight || 0

    this.style.setProperty('--Top', `${contentHeight}px`)
    this.style.setProperty('--Style_Height', `${styleHeight}px`)
    this.style.setProperty('--Tabs_Height', `${tabsHeight}px`)
  }
}

if (!customElements.get('product-content')) {
  customElements.define('product-content', ProductContent)
}
